import { useMemo } from 'react';
import { useCategories } from './useCategories.js';
import { buildCols, buildTree, buildNodeIndex } from '../lib/cashflow-tree.js';

/**
 * Modèle de lignes partagé par le tableau cash-flow et la vue « mois » mobile :
 * colonnes, arbre de catégories agrégé et index par id.
 */
export function useCashFlowRows({ byCategory = [], buckets = [] }) {
  const { data: categoriesRaw } = useCategories();
  const categories = Array.isArray(categoriesRaw)
    ? categoriesRaw
    : categoriesRaw?.categories ?? categoriesRaw?.data ?? [];

  const periodStarts = useMemo(() => buckets.map((b) => b.period_start), [buckets]);

  const bucketByPeriod = useMemo(() => {
    const m = new Map();
    for (const b of buckets) m.set(b.period_start, b);
    return m;
  }, [buckets]);

  const cols = useMemo(() => buildCols(buckets), [buckets]);

  const byCategoryMap = useMemo(() => {
    const m = new Map();
    for (const c of byCategory) m.set(c.category_id, c);
    return m;
  }, [byCategory]);

  const tree = useMemo(() => {
    if (!categories.length) return [];
    return buildTree(categories, byCategoryMap, periodStarts);
  }, [categories, byCategoryMap, periodStarts]);

  const nodeById = useMemo(() => buildNodeIndex(tree), [tree]);

  return { cols, periodStarts, bucketByPeriod, tree, nodeById };
}
